/**
 * The TA workbench's own vocabulary (GRA-83), and its one-way translation to
 * KLineChart's overlay and indicator names. `DrawingToolId` and `IndicatorId`
 * are ours: everything outside the Chart adapter (TAToolbar, useTAWorkbench,
 * settingsStore) speaks these ids and never sees a KLineChart name. The two
 * translation tables below carry the only KLineChart names outside Chart.tsx
 * itself, and only Chart.tsx imports them, so a KLineChart rename touches one
 * file instead of silently corrupting persisted settings.
 */

/** A drawing tool the player can activate on the chart. */
export type DrawingToolId = "line" | "hline" | "fib";

/** The canonical indicator id list; `IndicatorId` derives from it. */
export const INDICATOR_IDS = ["sma", "ema", "bbands", "rsi", "macd", "vol"] as const;

/** An indicator overlay the player can toggle on the chart. */
export type IndicatorId = (typeof INDICATOR_IDS)[number];

/** Domain drawing tool id to KLineChart overlay name. Chart.tsx only. */
export const DRAWING_TOOL_KLINE_NAMES: Record<DrawingToolId, string> = {
  line: "straightLine",
  hline: "horizontalStraightLine",
  fib: "fibonacciLine",
};

/** Domain indicator id to KLineChart built-in indicator name. Chart.tsx only. */
export const INDICATOR_KLINE_NAMES: Record<IndicatorId, string> = {
  sma: "MA",
  ema: "EMA",
  bbands: "BOLL",
  rsi: "RSI",
  macd: "MACD",
  vol: "VOL",
};
